import React, { Component } from 'react';

class Details extends Component {
  ga = (index) => {
    let location;
    switch (index) {
      case 0:
        location = 'Alphabet City';
        break;
      case 1:
        location = 'World Trade Center';
        break;
      case 2:
        location = 'Astor Place';
        break;
      default:
        location = 'Undefined';
    }

    window.ga('send', 'event', 'Book Appointment', 'click', location);
  };

  render() {
    return (
      <div>
        <div className="columns">
          <div className="column is-4">
          <div className="content">
            <h4>Alphabet City</h4>
            <p>Located at 10th Street, between Avenue B and C. Closest train stop is 1st Avenue [L] and approximately 12 minutes walk to the salon.</p>
            <div className="columns is-mobile">
              <div className="column is-1">
                <p><i className="fas fa-map-marker-alt"></i></p>
              </div>
              <div className="column is-11">
                <p>380 East 10th Street<br />New York, NY 10009</p>
                {this.props.currentMap !== 0 && <button className="button is-rounded" onClick={() => this.props.changeMap(0)}>Show map</button>}
              </div>
            </div>
            <div className="columns is-mobile">
              <div className="column is-1">
                <p><i className="fas fa-phone"></i></p>
              </div>
              <div className="column is-11">
                <p>212-505-0537</p>
              </div>
            </div>
            <div className="columns is-mobile">
              <div className="column is-1">
                <p><i className="far fa-clock"></i></p>
              </div>
              <div className="column is-11">
                <p>Monday&ndash;Friday 11 AM&ndash;7 PM<br />Saturday 11 AM&ndash;6 PM</p>
              </div>
            </div>
            <div className="columns is-mobile">
              <div className="column is-1"></div>
              <div className="column is-11">
                <a className="button is-info" href="https://squareup.com/appointments/book/VNJV4JGQZ0QHC/i-salon-alphabet-city-new-york-ny" target="_blank" rel="noopener noreferrer" onClick={() => this.ga(0)}>Book appointment&nbsp;<i className="fas fa-external-link-alt"></i></a>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default Details;



// WEBPACK FOOTER //
// ./src/Locations/Details/index.js